import { render, staticRenderFns } from "./distconfig-add-or-update.vue?vue&type=template&id=9a1032b0&"
import script from "./distconfig-add-or-update.vue?vue&type=script&lang=js&"
export * from "./distconfig-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports